import { BASE_API } from "../../api/Globals";
import { helpHttp } from "../../helpers/helpHttp";
import { storage } from "../../helpers/storage";

/**
 * Obtiene el archivo Excel del reporte histórico de evidencias (en Base64).
 * @returns {Promise<string|null>} - Retorna el string Base64 si fue exitoso, o null si falló.
 */
export const ReporteHistoricoEvidencias = async () => {
  try {
    const res = await helpHttp().post(`${BASE_API}Reportes/spdReportes`, {
      body: {
        Opcion: 8,
        ParametrosExtra: ""
      },
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Accept": "application/json",
        "Authorization": `Bearer ${storage.get("token")}`
      }
    });

    if (res?.SUCCESS && res?.ITEMS) {
      return res.ITEMS; // ✅ Devuelve el Base64 directamente
    } else {
      console.error("Error en la respuesta del servidor:", res);
      return null;
    }
  } catch (error) {
    console.error("Error obteniendo reporte:", error);
    return null;
  }
};
